import { get } from './index'

// 获取合作伙伴列表
export const getPartners = (params = {}) => {
  return get('/org/list', params)
}

// 获取合作伙伴详情
export const getPartnerDetail = (id) => {
  return get(`/org/getOrgById?orgId=${id}`)
} 